import { formatScheduleDate } from '@src/domains/scheduling';
import type { CartItem, DetailedSaleItem } from '@src/domains/cart';

export const getPackageDates = (items: (CartItem | DetailedSaleItem)[], locale?: string) => {
  const dates = items
    .filter((item) => item.scheduleDate)
    .map((item) => formatScheduleDate(item.scheduleDate || '', locale));

  return [...new Set(dates)].join(' - ');
};
